import * as Types from '../generated/graphql';

import { gql } from '@apollo/client/core/core.cjs';
import * as Apollo from '@apollo/client/core/core.cjs';
const defaultOptions = {} as const;
export type PatientWalletByFirebaseUidQueryVariables = Types.Exact<{
  uid: Types.Scalars['String']['input'];
  workspaceId: Types.Scalars['uuid']['input'];
}>;


export type PatientWalletByFirebaseUidQuery = { __typename?: 'query_root', patientWallet: Array<{ __typename?: 'patientWallet', balance: number, patient: { __typename?: 'patient', patientAddresses: Array<{ __typename?: 'patientAddress', type: string, address: { __typename?: 'address', id: any, addressLine1: string, city: string, state: string, zipCode: string } }>, patientWorkspaces: Array<{ __typename?: 'patientWorkspace', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null }> } }> };


export const PatientWalletByFirebaseUidDocument = gql`
    query PatientWalletByFirebaseUid($uid: String!, $workspaceId: uuid!) {
  patientWallet(
    where: {patient: {firebaseUid: {_eq: $uid}}, workspaceId: {_eq: $workspaceId}}
  ) {
    balance
    patient {
      patientAddresses {
        type
        address {
          id
          addressLine1
          city
          state
          zipCode
        }
      }
      patientWorkspaces {
        firstName
        lastName
        email
        phoneNumber
      }
    }
  }
}
    `;

/**
 * __usePatientWalletByFirebaseUidQuery__
 *
 * To run a query within a React component, call `usePatientWalletByFirebaseUidQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWalletByFirebaseUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientWalletByFirebaseUidQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function usePatientWalletByFirebaseUidQuery(baseOptions: Apollo.QueryHookOptions<PatientWalletByFirebaseUidQuery, PatientWalletByFirebaseUidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientWalletByFirebaseUidQuery, PatientWalletByFirebaseUidQueryVariables>(PatientWalletByFirebaseUidDocument, options);
      }
export function usePatientWalletByFirebaseUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientWalletByFirebaseUidQuery, PatientWalletByFirebaseUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientWalletByFirebaseUidQuery, PatientWalletByFirebaseUidQueryVariables>(PatientWalletByFirebaseUidDocument, options);
        }
export function usePatientWalletByFirebaseUidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PatientWalletByFirebaseUidQuery, PatientWalletByFirebaseUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PatientWalletByFirebaseUidQuery, PatientWalletByFirebaseUidQueryVariables>(PatientWalletByFirebaseUidDocument, options);
        }
export type PatientWalletByFirebaseUidQueryHookResult = ReturnType<typeof usePatientWalletByFirebaseUidQuery>;
export type PatientWalletByFirebaseUidLazyQueryHookResult = ReturnType<typeof usePatientWalletByFirebaseUidLazyQuery>;
export type PatientWalletByFirebaseUidSuspenseQueryHookResult = ReturnType<typeof usePatientWalletByFirebaseUidSuspenseQuery>;
export type PatientWalletByFirebaseUidQueryResult = Apollo.QueryResult<PatientWalletByFirebaseUidQuery, PatientWalletByFirebaseUidQueryVariables>;